import React, { createContext, ReactNode, useContext } from 'react'
import {
  ElectronUpdaterHookResult,
  useElectronUpdater,
} from '~/hooks/useElectronUpdater'

const defaultUpdaterContextValue: ElectronUpdaterHookResult = {
  statusMessage: '',
  isUpdateAvailable: false,
  isUpdateDownloaded: false,
  isChecking: false,
  error: null,
  isUpdateBlocked: false,
  updateBlockedDownloadUrl: null,
  isUpdateNotAvailable: false,
  downloadPercent: null,
  updateRequirement: null,
  lastInstallOutcome: null,
  updatePermissionHelpUrl: null,
  lastCheckStatus: 'pending',
  permissionRecheckCount: 0,
  availableVersion: null,
  checkForUpdates: () => {
    console.warn('checkForUpdates called outside ElectronUpdaterProvider')
  },
  updateIgnoringInstallPermission: () => {
    console.warn(
      'updateIgnoringInstallPermission called outside ElectronUpdaterProvider',
    )
  },
  quitAndInstall: () => {
    console.warn('quitAndInstall called outside ElectronUpdaterProvider')
  },
  setClearMessageDelay: () => {
    console.warn('setClearMessageDelay called outside ElectronUpdaterProvider')
  },
}

const ElectronUpdaterContext = createContext<ElectronUpdaterHookResult>(
  defaultUpdaterContextValue,
)

interface ElectronUpdaterProviderProps {
  children: ReactNode
}

const THREE_HOURS_MS = 3 * 60 * 60 * 1000 // 3 hours, in ms

export const ElectronUpdaterProvider: React.FC<
  ElectronUpdaterProviderProps
> = ({ children }) => {
  const updaterState = useElectronUpdater(THREE_HOURS_MS)

  return (
    <ElectronUpdaterContext.Provider value={updaterState}>
      {children}
    </ElectronUpdaterContext.Provider>
  )
}

export const useElectronUpdaterContext = (): ElectronUpdaterHookResult => {
  const context = useContext(ElectronUpdaterContext)

  if (context === defaultUpdaterContextValue) {
    throw new Error(
      'useElectronUpdaterContext must be used within an ElectronUpdaterProvider',
    )
  }
  return context
}
